<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://consultoriafuturo.com.br/"
        target="_blank"
      >{{ companyName }}</b-link>
      <span class="d-none d-sm-inline-block">, todos os direitos reservados.</span>
      <span v-if="appVersion" class="d-none d-sm-inline-block">&nbsp; Versão: {{ appVersion }}</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION
    },
    companyName() {
      return process.env.VUE_APP_COMPANY_NAME || 'FUTURO Corp'
    },
  },
}
</script>
